(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('unbound-menu-promos')) { customElements.define('unbound-menu-promos', class extends HTMLElement { connectedCallback() { if(this.timer) clearInterval(this.timer); if(!this.ready) { this.ready=true; const track=this.querySelector('.ub-menu-promos-track'); const dots=[...this.querySelectorAll('[data-slide]')]; this.current=0; this.go=index=>{this.current=(index+dots.length)%dots.length;track.scrollTo({left:this.current*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.dataset.slide!==undefined)this.go(Number(button.dataset.slide));if(button.dataset.direction)this.go(this.current+Number(button.dataset.direction));});track.addEventListener('scroll',()=>{this.current=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((dot,index)=>index===this.current?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));},{passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.go(this.current+(event.key==='ArrowRight'?1:-1));}}); } this.timer=setInterval(()=>{if(!document.hidden&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&this.closest('details')?.open)this.go(this.current+1);},2500); } disconnectedCallback(){clearInterval(this.timer);this.timer=null;} }); }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["unbound-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
    const key = 'unbound-wishlist-v1';
    const eventName = 'unbound:wishlist-change';
    const read = () => {
      try {
        const items = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(items) ? items.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/products/')).slice(0, 100) : [];
      } catch { return []; }
    };
    const save = items => {
      try { localStorage.setItem(key, JSON.stringify(items)); document.dispatchEvent(new Event(eventName)); return true; }
      catch { return false; }
    };
    class WishlistHeart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.sync = () => {
          const active = read().some(item => item.id === this.dataset.id);
          this.button.setAttribute('aria-pressed', String(active));
          this.button.setAttribute('aria-label', `${active ? this.dataset.remove : this.dataset.save}: ${this.dataset.title}`);
        };
        this.toggle = event => {
          event.preventDefault();event.stopPropagation();
          const items = read();
          const active = items.some(item => item.id === this.dataset.id);
          const next = active ? items.filter(item => item.id !== this.dataset.id) : [...items, { id:this.dataset.id, title:this.dataset.title, url:this.dataset.url, image:this.dataset.image }];
          if (!save(next.slice(-100))) this.querySelector('[role="status"]').textContent = this.dataset.error;
        };
        this.button.addEventListener('click', this.toggle);
        document.addEventListener(eventName, this.sync);window.addEventListener('storage', this.sync);this.sync();
      }
      disconnectedCallback() { this.button.removeEventListener('click',this.toggle);document.removeEventListener(eventName,this.sync);window.removeEventListener('storage',this.sync); }
    }
    class WishlistList extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('.ub-wishlist-open');
        this.open = () => { this.sync();this.dialog.showModal(); };
        this.close = () => this.dialog.close();
        this.outside = event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect();if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close(); } };
        this.sync = () => {
          const items = read();this.querySelector('[data-count]').textContent = items.length;
          const list = this.querySelector('[data-items]');list.replaceChildren();
          if (!items.length) { const empty = document.createElement('p');empty.textContent = this.dataset.empty;list.append(empty); }
          items.forEach(item => {
            const row = document.createElement('div');row.className = 'ub-wishlist-item';
            const image = document.createElement('img');image.alt = item.title;image.loading = 'lazy';
            try { const src = new URL(item.image, location.origin);if (src.protocol === 'https:') image.src = src.href; } catch {}
            const body = document.createElement('div');const link = document.createElement('a');link.href = item.url;link.textContent = item.title;
            const remove = document.createElement('button');remove.type = 'button';remove.textContent = this.dataset.remove;remove.setAttribute('aria-label', `${this.dataset.remove}: ${item.title}`);
            remove.addEventListener('click', () => { if (!save(read().filter(saved => saved.id !== item.id))) this.querySelector('[data-status]').textContent = this.dataset.error; });
            body.append(link,remove);row.append(image,body);list.append(row);
          });
        };
        this.openButton.addEventListener('click',this.open);this.querySelector('[data-close]').addEventListener('click',this.close);this.dialog.addEventListener('click',this.outside);
        document.addEventListener(eventName,this.sync);window.addEventListener('storage',this.sync);this.sync();
      }
      disconnectedCallback() { this.openButton.removeEventListener('click',this.open);this.querySelector('[data-close]').removeEventListener('click',this.close);this.dialog.removeEventListener('click',this.outside);document.removeEventListener(eventName,this.sync);window.removeEventListener('storage',this.sync); }
    }
    if (!customElements.get('ub-wishlist')) customElements.define('ub-wishlist',WishlistHeart);
    if (!customElements.get('ub-wishlist-list')) customElements.define('ub-wishlist-list',WishlistList);
  })();
  } catch(e) { console.error(e); }
})();

})();
